import Button from '@mui/material/Button';

const ExportCSV = ({ data, oper, chosenDate, err }) => {
    const downloadCSV = () => {
     
        console.log("Exporting!");
        console.log(oper);
        console.log(err);

        console.log(data.length)

        console.log("Starting");
      const csvString = [
        ["Telefon", "Ime", "Prezime", "Mjesto", "Postanski broj", "Ulica", "Kucni broj", "Kucno slovo", "Tip korisnika"], 
        ...data.map(item => [item[0].Tel, item[0].Naziv1, item[0].Naziv2, item[0].Mjesto, item[0].PostBroj, item[0].Ulica, 
            item[0].KucniBr, item[0].KucnoSlovo, item[0].TipKorisnika]) 
      ]
      .map(row => row.join(","))
      .join("\n");
  
  
      const universalBOM = "\uFEFF";
      const csv = universalBOM + csvString;
      //const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8' });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

     
  

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');


      //const universalBOM = "\uFEFF";
      //link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));


      link.href = url;
      let fName = '';
      if(oper && oper.naziv && oper.naziv!=''){
            fName = fName + oper.naziv;
      }
      if(err && err.naziv && err.naziv!=''){
            if(fName != ''){
                    fName = fName + '_' + err.naziv.replace(/ /g, '');
            } else {
                    fName = err.naziv.replace(/ /g, ''); 
            }
            
      }
      console.log("Date");
      console.log(chosenDate)
      if(chosenDate && chosenDate!=''){

            console.log("Date is?");
            console.log(chosenDate);

            let checkedNew = chosenDate.split('.').join("");

            console.log(checkedNew);

            fName = fName + "_" + checkedNew;

      }else {
            console.log("Nije odabran datum!");
      }

      console.log(fName);

      if(fName != ''){

            fName = fName + '.csv';
      } else {

            fName = 'download.csv';
      }


      link.download = fName || 'download.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
  
    return <Button sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="info" 

                    onClick={() => {

                        console.log("Calling export!!!");

                        downloadCSV();

                    }}
             
                    >
                    Spremi datoteku
            </Button>
    //return <button onClick={downloadCSV}>Spremi datoteku</button>;
  };
  
  export default ExportCSV;